/* eslint-disable no-underscore-dangle */
import * as qs from 'qs';
import request from '../utils/request';

// list
export const getDeviceList = (params) => request(`admin/device?${qs.stringify(params)}`);
export const creatDevice = (data) => request({
  url: 'admin/device',
  method: 'post',
  data,
});
export const modifyDevice = (data) => request({
  url: `admin/device/${data._id}`,
  method: 'put',
  data,
});
export const deleteDevice = (id) => request({
  url: `admin/device/${id}`,
  method: 'delete',
});
export const getAllDevice = (params) => request(`admin/device/all-device?${qs.stringify(params)}`);
export const syncStatus = (id) => request(`admin/device/sync-status/${id}`);

export const getDeviceLogs = (params) => request(`admin/device-log?${qs.stringify(params)}`);
